<form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()" autocomplete="off" style="margin-top: 8px">
  <div class="form-fields">
    <!-- New Password Field -->
    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="newPassword" placeholder="New Password" required data-lpignore="true" autocomplete="off" />
      @if (newPassword.hasError("required")) {
        <mat-error> New Password Required </mat-error>
      } @else if (newPassword.hasError("strongPassword")) {
        <mat-error> New Password must be at least 8 characters long and include a letter, a number, and a special character. </mat-error>
      }
    </mat-form-field>
    <!-- Confirm Password Field -->
    <mat-form-field appearance="outline">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" placeholder="Confirm Password" required data-lpignore="true" autocomplete="off" />
      @if (confirmPassword.hasError("required")) {
        <mat-error> Confirm Password Required </mat-error>
      } @else if (confirmPassword.hasError("strongPassword")) {
        <mat-error> Confirm Password must be at least 8 characters long and include a letter, a number, and a special character. </mat-error>
      }
      <!--  -->
    </mat-form-field>
    @if (form.hasError("passwordsMismatch") && confirmPassword.touched) {
      <mat-error> Passwords do not match </mat-error>
    }

    <!-- Submit Button -->
    <div class="submit-btn-wrapper">
      <!-- Create User -->
      <button mat-flat-button type="submit" [disabled]="form.invalid || saveState()">Submit</button>
    </div>
  </div>
</form>
